"use client";
import React, { Fragment } from "react";
import { Box, Flex, Stack } from "@chakra-ui/react";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { usePricingContext } from "@/context/pricingContext";
import { PricingType } from "@/types/pricing";
import FrequencySelect from "../components/frequencySelect";
import OsSelect from "../components/osSelect";
import SortSelect from "../components/sortSelect";
import { useHandleFrequency } from "../hooks/useHandleFrequency";
import { useHandleOs } from "../hooks/useHandleOs";
import { useHandleSortState } from "../hooks/useHandleSortState";
import { SORT_OPTIONS } from "./constants";
import { DesktopView, MobileView } from "./table";

type Props = {
  os?: string[];
};

const CloudHostedTables = (props: Props) => {
  const { os } = props;
  const { cloudInstancePricing } = usePricingContext();

  return (
    <Fragment>
      {cloudInstancePricing && (
        <TableWithData pricingData={cloudInstancePricing} os={os} />
      )}
    </Fragment>
  );
};

const TableWithData = (props: Props & { pricingData: PricingType }) => {
  const { os, pricingData } = props;
  const { operating_systems, plans } = pricingData;
  const { handleOSChange, osOptions, selectedOS } = useHandleOs(operating_systems, os);
  const { frequencyOptions, handleFrequencyChange, selectedFrequency } =
    useHandleFrequency(selectedOS);
  const { handleSortingChange, sortField, sortOrder } = useHandleSortState(
    "config.vcpu",
    "asc"
  );

  return (
    <Box id="cloud-instances">
      <SectionDivider label={"Cloud Instances"} />

      <Flex direction={{ base: "column", sm: "row" }} justifyContent={"space-between"}>
        <Stack direction={{ base: "column", sm: "row" }}>
          <Box width={{ base: "full", sm: "220px" }}>
            <OsSelect
              osOptions={osOptions}
              onChange={handleOSChange}
              value={selectedOS.id}
            />
          </Box>
          <Box width={{ base: "full", sm: "220px" }}>
            <FrequencySelect
              frequencyOptions={frequencyOptions}
              onChange={handleFrequencyChange}
              value={selectedFrequency.value}
            />
          </Box>
        </Stack>
        <Box width={{ base: "full", sm: "220px" }}>
          <SortSelect
            onChange={handleSortingChange}
            sortOptions={SORT_OPTIONS}
            value={`${sortField}-${sortOrder}`}
          />
        </Box>
      </Flex>
      <Box pt={7} pb={5} display={{ base: "block", sm: "none" }}>
        <MobileView
          plans={plans}
          selectedOS={selectedOS}
          selectedFrequency={selectedFrequency}
          sortField={sortField}
          sortOrder={sortOrder}
        />
      </Box>
      <Box
        pt={7}
        pb={5}
        display={{ base: "none", sm: "block" }}
        overflowX={"auto"}
        width={{ md: "66w", lg: "inherit" }}
      >
        <DesktopView
          plans={plans}
          selectedOS={selectedOS}
          selectedFrequency={selectedFrequency}
          sortField={sortField}
          sortOrder={sortOrder}
        />
      </Box>
    </Box>
  );
};

export default CloudHostedTables;
